import { render, staticRenderFns } from "./GestionConfigurationVendeur.vue?vue&type=template&id=48786bdc&scoped=true&"
import script from "./GestionConfigurationVendeur.vue?vue&type=script&lang=js&"
export * from "./GestionConfigurationVendeur.vue?vue&type=script&lang=js&"
import style0 from "./GestionConfigurationVendeur.vue?vue&type=style&index=0&id=48786bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48786bdc",
  null
  
)

export default component.exports